<template>
    <div class="flex-column ml-n2 mr-n2">
        <div class="block block-rounded block-bordered">
            <div class="block-header">
                <div class="block-title">
                    APIs and Services
                </div>
                <div class="block-options">
                    <div v-if="$hasRole('admin')">
                        <button type="button" class="btn btn-sm btn-outline-primary" @click="createApiProduct">
                            <i class="fas fa-fw fa-plus mr-1"></i> New Product
                        </button>
                    </div>
                </div>
            </div>
            <div class="block-content block-content-full tab-content border-top" v-loading="editingApiProduct">
                <div class="tab-pane active">
                    <table class="table table-striped table-hover table-borderless table-vcenter font-size-sm">
                        <thead>
                        <tr class="text-uppercase">
                            <th style="width: 20px;">#</th>
                            <th class="font-w700">Product</th>
                            <th class="d-none d-sm-table-cell font-w700">Description</th>
                            <th class="font-w700" style="width: 120px;">Access</th>
                            <th class="d-none d-sm-table-cell font-w700 text-right" style="width: 150px;">Created On
                            </th>
                            <th v-if="$hasRole('admin')" class="font-w700 text-center" style="width: 60px;"></th>
                        </tr>
                        </thead>
                        <tbody v-if="products.length > 0">
                        <tr v-for="(product, index) in products" :key="index">
                            <td>
                                {{++index}}
                            </td>
                            <td>
                                <span class="font-w600">{{product.name}}</span>
                            </td>
                            <td class="d-none d-sm-table-cell">
                                <span class="font-size-sm text-muted">{{product.description}}</span>
                            </td>
                            <td>
                            <span class="font-w700 badge"
                                  :class="{
                                      'badge-danger': product.access === 'private',
                                      'badge-primary': product.access === 'internal' ,
                                      'badge-success': product.access === 'public'
                                  }"
                            >
                                {{product.access}}
                            </span>
                            </td>
                            <td class="d-none d-sm-table-cell text-right">
                                {{product.created_at}}
                            </td>
                            <td class="text-center" v-if="$hasRole('admin')">
                                <div class="dropdown">
                                    <button type="button" class="btn-block-option" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                        <i class="si si-menu"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-right">
                                        <li>
                                            <a class="dropdown-item" @click="editProduct(product.id)"
                                               href="javascript:void(0)">
                                                <i class="si si-pencil mr-1"></i>
                                                Edit Service
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" @click="deleteProduct(product.id)"
                                               href="javascript:void(0)">
                                                <i class="si si-trash text-danger mr-1"></i>
                                                Delete Service
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot>

                        </tfoot>
                    </table>
                    <div class="flex-column" v-if="products.hasOwnProperty('data')">
                        <div class="col-auto">
                            <eml-pagination align="right" :data="products"
                                        @pagination-change-page="getApiProducts">
                            </eml-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-api-product v-if="creatingProduct"/>
        <edit-api-product v-if="updatingApiProduct"/>
    </div>
</template>

<script>
    import CreateProduct from './CreateApiProduct';
    import {mapGetters, mapActions} from 'vuex';
    import EditProduct from './EditApiProduct';
    import jQuery from 'jquery';

    export default {
        name: "ProductsDashboard",
        components: {
            'create-api-product': CreateProduct,
            'edit-api-product': EditProduct,
        },
        mounted() {
            this.$store.dispatch('getApiProducts');
        },
        computed: {
            ...mapGetters({
                creatingProduct: 'getCreatingApiProduct',
                updatingApiProduct: 'getUpdatingApiProduct',
                products: 'getProducts',
                editingApiProduct: 'editingApiProduct',
            })
        },
        methods: {
            ...mapActions([
                'getApiProducts'
            ]),

            deleteProduct(id) {
                this.$confirm('This will permanently delete the API Product. Continue?', 'Warning', {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('deleteProduct', id).then(() => {
                        this.$message({type: 'success', message: 'Api Product was delete'});
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete action was canceled'
                    });
                });
            },
            /**
             *
             * @param id
             */
            editProduct(id) {
                this.$store.commit('setEditingApiProduct', true);
                this.$store.dispatch('findApiProductById', id).then(() => {
                    this.$store.commit('setUpdatingApiProduct', true);
                    setTimeout(()=> {
                        jQuery('#edit-api-product').modal('show');
                        this.$store.commit('setEditingApiProduct', false);
                    }, 1000);
                });
            },

            createApiProduct() {
                this.$store.commit('setCreatingApiProduct', true);
                setTimeout(() => {
                    jQuery('#create-api-product').modal('show');
                }, 100);
            }
        }
    }
</script>

<style scoped>
    .block-content {
        padding: 5px !important;
    }
</style>
